import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { CommonService } from '../shared/providers/common.service';
import { ToastService } from '../shared/providers/toast.service';
import { ValidationService } from '../shared/providers/validation.service';
import { IUserRole } from '../shared/models/UserRoleOutputModel';
import { RoleBasedPermissionListModel } from '../shared/models/RoleBasedPermissionListModel';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { ModuleActionList } from '../shared/models/ModuleActionList';
import { UserModuleList } from '../shared/models/UserModuleList';
import { PermissionService } from '../shared/providers/permission.service';
import { Module } from 'node:vm';
import { Action } from 'rxjs/internal/scheduler/Action';
import { LoaderService } from '../shared/providers/loader.service';

@Component({
  selector: 'app-role-permissions',
  templateUrl: './role-permissions.component.html',
  styleUrls: ['role-permissions.component.css'],
})
export class RolePermissionsComponent implements OnInit {

  user: any;
  userRoles: IUserRole[];
  roleBasedPermissions: RoleBasedPermissionListModel[] = [];
  modules: UserModuleList[] = [];
  actionList: ModuleActionList[] = [];
  data: any[];
  IsDiscardButtonVisible = false;
  originalPermissions: UserModuleList[] = [];
  constructor(private http: HttpClient, public authService: AuthenticationService,protected loaderService: LoaderService, public Validation: ValidationService, private permissionService: PermissionService, private _userManagerService: UserManagerService, private _commonService: CommonService, private _toastService: ToastService) { }
  ngOnInit() {
    this.user = this.authService.user;
    this.loaderService.display(true);
    this.getUserRoles();
    this.LoadPermissions();
  }

  toggleModule(module: any) {
    module.IsExpanded = !module.IsExpanded;
  }

  LoadPermissions() {
    this._userManagerService.GetAllPermissions().subscribe(response => {
      this.modules = response;
      this.originalPermissions = structuredClone(this.modules);
      this.loaderService.display(false);
    });
  }

  SavePermissions() {
    this.loaderService.display(true);
    if (this.modules.length) {
      this.modules[0].UserId = this.user.Id;
    }
    this._userManagerService.SaveUserRolePermissions(this.modules).subscribe(response => {
      if (response) {
        this._toastService.addToast({ title: 'Success', msg: 'Permissions Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.originalPermissions = structuredClone(this.modules);
        this.IsDiscardButtonVisible = false;
        this.loaderService.display(false);
        this.loadRoleBasedPermissions(this.user.RoleId);

      }
      else {
        this.loaderService.display(false);
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Something went wrong', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
  }

  async getUserRoles() {
    await this._commonService.getUserRolesListForPermissions().subscribe((response) => {
      this.userRoles = response
        .map((o) => {
          return { id: o.Id, name: o.Description };
        });
    });
  }

  onDiscardChanges() {
    this.modules = structuredClone(this.originalPermissions);
    this.IsDiscardButtonVisible = false;
  }

  onPermissionChange() {
    this.IsDiscardButtonVisible = true;
  }

  getPermission(action: any, roleId: number) {
    return action.Permissions.find(
      (p: any) => p.roleId === roleId
    );
  }

  loadRoleBasedPermissions(roleId: number) {
    this.permissionService.getAllowedPermissions(roleId).subscribe(response => {
      this.permissionService.setPermissions(response);
    });
  }

  getCurrentPermission(action: any, role: any) {
    return action.Permissions?.find(
      (p: any) => p.RoleId === role.id
    );
  }

  onPermissionToggle(action: any, role: any, value: boolean) {
    this.IsDiscardButtonVisible = true;
    const permission = this.getCurrentPermission(action, role);
    if (permission) {
      permission.IsActive = value;
      this.onPermissionChange();
    }
  }
}
